import React from 'react';
import BackgroundImage from 'routes/auth/components/container/background.png';
import {
  Button,
  Header,
  HeaderStyledLogoIcon,
  HeaderInnerRight,
  HeaderInnerRightLabelText,
  Container,
  InnerContainer,
  InnerLeft,
  InnerLeftInner,
  Title,
  InnerRight,
  InnerRightImageHolder,
  InnerRightImage,
  HeaderStyledLogoIconImmo,
} from 'routes/auth/components/container/style';
import useEventListener from 'hooks/use-event-listener';
import { useTheme } from 'styled-components';
/**
 * Common container for the login/register component
 * @param children content
 * @param ctaLabelText header call-to-action text
 * @param ctaButtonText header call-to-action button text
 * @param titleText test for the content title
 * @param onCtaButtonClick handle header call-to-action button click
 * @constructor
 */
export default function AuthContainer({
  children,
  ctaLabelText,
  ctaButtonText,
  titleText,
  onCtaButtonClick,
}: {
  children?: any;
  ctaLabelText?: string;
  ctaButtonText?: string;
  titleText?: string;
  onCtaButtonClick?: () => void;
}) {
  const [halfScreen, setHalfScreen] = React.useState(window.innerHeight / 2);

  useEventListener('resize', calcHalfScreen);

  React.useEffect(() => {
    document.body.style.overflowY = 'auto';
    document.documentElement.style.overflowY = 'auto';

    calcHalfScreen();

    return () => {
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    };
  }, []);

  function calcHalfScreen() {
    setHalfScreen(window.innerHeight / 2);
  }
  const theme = useTheme();

  return (
    <Container>
      <Header>
        {theme.name == 'cortlex' && <HeaderStyledLogoIcon />}
        {theme.name == 'immoox' && <HeaderStyledLogoIconImmo />}
        <HeaderInnerRight>
          <div>
            {ctaLabelText && (
              <HeaderInnerRightLabelText>
                {ctaLabelText}
              </HeaderInnerRightLabelText>
            )}
            {ctaButtonText && (
              <Button onClick={onCtaButtonClick} label={ctaButtonText} />
            )}
          </div>
        </HeaderInnerRight>
      </Header>
      <InnerContainer>
        <InnerLeft top={halfScreen}>
          <InnerLeftInner>
            {titleText && <Title>{titleText}</Title>}
            {children}
          </InnerLeftInner>
        </InnerLeft>
        <InnerRight>
          <InnerRightImageHolder>
            <InnerRightImage src={BackgroundImage} />
          </InnerRightImageHolder>
        </InnerRight>
      </InnerContainer>
    </Container>
  );
}
